// src/reducers/taxReducer.js

import {types} from '../types/types';

const initialState = {
    editingTax: {
        id: 0,
        name: '',
        code: '',
        realmFk: '',
        status: true,
    },
    editingTaxValue: {
        id: 0,
        validFrom: '',
        validUntil: '',
        percent: null,
        flat: null,
        realmFk: '',
        taxId: 0,
        taxName: '',
        status: true,
    },
    editingTaxProduct: {
        id: 0,
        productFk: 0,
        productName: '',
        taxFk: 0,
        taxName: '',
        realmFk: '',
        status: true
    }
};

export const taxReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingTaxInfo:
            return {
                ...state,
                editingTax: action.payload
            };

        case types.clearTaxInfo:
            return {
                ...state,
                editingTax: initialState.editingTax
            };

        case types.editingTaxValueInfo:
            return {
                ...state,
                editingTaxValue: action.payload
            };

        case types.clearTaxValueInfo:
            return {
                ...state,
                editingTaxValue: initialState.editingTaxValue
            };

        case types.editingTaxProductInfo:
            return {
                ...state,
                editingTaxProduct: action.payload
            };

        case types.clearTaxProductInfo:
            return {
                ...state,
                editingTaxProduct: initialState.editingTaxProduct
            };

        default:
            return state;
    }
};